import {Button} from '@/base/ui/button'
import {WuLoader} from '@/components/loader'
import {cn} from '@/lib/utils'
import {forwardRef, ReactNode} from 'react'

export interface IWuButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'rounded'
    | 'link'
    | 'iconOnly'
  size?: 'md' | 'sm' | 'mobile'
  color?: 'primary' | 'upgrade' | 'error'
  Icon?: ReactNode
  iconPosition?: 'left' | 'right'
  floating?: boolean
  disabled?: boolean
  loading?: boolean
  dir?: 'rtl' | 'ltr'
}

export const WuButton = forwardRef<HTMLButtonElement, IWuButtonProps>(
  (
    {
      disabled,
      loading,
      variant = 'primary',
      size = 'md',
      Icon,
      iconPosition = 'left',
      children,
      floating,
      className,
      color = 'primary',
      ...props
    },
    ref,
  ) => {
    const loadColorMap = {
      primary: '#1986e688',
      upgrade: '#f5830088',
      error: '#ef444488',
    }
    return (
      <Button
        {...props}
        disabled={disabled}
        variant={variant}
        size={size}
        className={cn(
          floating && 'shadow-qp',
          'flex items-center justify-center gap-2',
          iconPosition === 'right' && 'flex-row-reverse',
          className,
          loading ? `cursor-not-allowed ring-0` : '',
        )}
        color={color}
        style={{backgroundColor: loading ? loadColorMap[color] : ''}}
        ref={ref}
      >
        {!loading && Icon && <>{Icon}</>}
        {loading && <WuLoader color="#fff" size="sm" />}
        {!loading && children}
      </Button>
    )
  },
)

WuButton.displayName = 'WuButton'
